/**
 * Fügt eine Klasse hinzu, wenn ein Element vom Selektor über den ViewPort nach links oder rechts hinausragt
 *
 * Event: window.load, window.resize
 * @param selector
 * @param classNameLeft
 * @param classNameRight
 */
function nc_initNavigationDropdownPosition(selector, classNameLeft, classNameRight) {
    $(window).load(function () {
        nc_navigationDropdownPosition('.top-nav .level-2', 'position-left', 'position-right');
    });
    $(window).resize(function () {
        nc_navigationDropdownPosition('.top-nav .level-2', 'position-left', 'position-right');
    });
}


/**
 * @see nc_initNavigationDropdownPosition
 *
 */
function nc_navigationDropdownPosition(selector, classNameLeft, classNameRight) {
    var windowRight = $(window).scrollLeft() + $(window).width();
    var windowLeft = $(window).scrollLeft();
    $(selector).each(function() {
        $(this).removeClass(classNameLeft);
        $(this).removeClass(classNameRight);
        if (windowLeft > $(this).offset().left) {
            $(this).addClass(classNameLeft);
        }
        if (windowRight < $(this).offset().left + $(this).outerWidth()) {
            $(this).addClass(classNameRight);
        }
    });
}
